export const statusProjectType = {
    active: "ACTIVO",
    pause: "PAUSA",
    concluid: "CONCLUIDO",
    cancel: "CANCELADO",
};
export const statusColor = {
    "ACTIVO": 'green',
    "PAUSA": '#FE7915hay',
    "CONCLUIDO": 'black',
    "CANCELADO": 'red',
};

export const statusProjectSemaforo = {
    green: "verde",
    yellow: "amarillo",
    red: "rojo",
    super_red: "super_rojo",
    purple: "morado",
};

export const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
